import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home-footer" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "home-footer-content" }, "Footer", -1)
const _hoisted_3 = [
  _hoisted_2
]


const __default__ = { name: 'HomeFooter' };

import {reactive, ref, onBeforeMount, onMounted} from 'vue';



export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose }) {

onMounted(() => {
  // console.log('3.-组件挂载到页面之后执行-------onMounted');
});
expose({
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}
}

})